export class SimulationConstants {
  public static CONVERSE_PROMPT_TYPE = 'CONVERSE';
  public static OVERALL_SCORE_PROMPT_TYPE = 'SCORE_OVERALL';
  public static MESSAGING_PROMPT_TYPE = 'MESSAGE_ADHERENCE';
  public static MESSAGING_PROMPT_TYPE_V2 = 'MESSAGE_ADHERENCE_V2';
  public static METHODOLOGY_PROMPT_TYPE = 'SCORE_CUSTOMIZED';
  public static SKILL_PROMPT_TYPE = 'SCORE_SKILLS';
  public static CLEAN_TRANSCRIPT_PROMPT_TYPE = 'CLEAN_TRANSCRIPT';
  public static STT_PROMPT_TYPE = 'STT_PROMPT';

  // reactive form internal structure
  public static GENERAL_SECTION = 'general';
  public static CONTENT_SECTION = 'content';
  public static SCORING_SECTION = 'scoring';
  public static SIMULATION_DETAILS_TABS_SECTION = 'simulationDetailtabs';
  public static METHODOLOGY_PROMPT_SECTION = 'methodologyPrompt';
  public static OVERALL_PROMPT_SECTION = 'overallScorePrompt';
  public static MESSAGING_PROMPT_SECTION = 'messagingPrompt';
  public static SKILL_PROMPT_SECTION = 'skillPrompt';
  public static SCORING_WEIGHTS_SECTION = 'sectionWeights';
  public static MESSAGING_THEME_SECTION = 'messagingTheme';
  public static FACT_SECTIONS_SECTION = 'factSections';
  public static FACTS_SECTION = 'facts';
  public static CALL_PERSONA_SECTION = 'callPersona';
  public static WELCOME_MESSAGE_SECTION = 'welcomeMessage';
  public static RESUME_MESSAGE_SECTION = 'resumeMessage';
  public static KEYWORDS_SECTION = 'keywords';
  public static STT_WORDS_SECTION = 'stt_words';
  public static CALL_WORDS_SECTION = 'call_words';
  public static REPLACE_WORDS_SECTION = 'replace_words';
  public static PRONOUNCE_WORDS_SECTION = 'pronounce_words';
  public static CLEAN_TRANSCRIPT_WORDS_SECTION = 'clean_transcript_words';

  public static SIMULATION_DETAILS_INFO_PATH = 'general.simulationDetailsInfo';
  public static CONVERSE_PROMPT_PATH = 'content.conversePrompt';
  public static CLEAN_TRANSCRIPT_PROMPT_PATH = 'content.cleanTranscriptPrompt';
  public static STT_PROMPT_PATH = 'content.sttPrompt';
  public static OVERALL_PROMPT_PATH = 'scoring.overallScorePrompt';
  public static METHODOLOGY_PROMPT_PATH = 'scoring.methodologyPrompt';
  public static MESSAGING_PROMPT_PATH = 'scoring.messagingPrompt';
  public static SKILL_PROMPT_PATH = 'scoring.skillPrompt';
  public static CALL_PERSONA_PATH = 'general.callPersona';
  public static MODULE_UUID_PATH = 'general.moduleUuid';
  public static KEYWORDS_PATH = 'keywords';
  public static STT_WORDS_PATH = 'keywords.stt_words';
  public static CALL_WORDS_PATH = 'keywords.call_words';
  public static REPLACE_WORDS_PATH = 'keywords.replace_words';

  public static PUBLISHED = 'Published';
  public static DRAFT = 'Draft';
  public static TESTING = 'Testing';

  public static readonly AUTOSAVE_GENERIC_DEBOUNCE = 2000;

  public static readonly SELFSERVE_LOCAL_STORAGE_PERSONA_INFO =
    'simulation_persona_information';

  public static readonly MESSAGING_SECTION = 'Messaging';
  public static readonly METHODOLOGY_SECTION = 'Methodology';
  public static readonly SKILLS_SECTION = 'Skills';

  public static readonly KEYWORDS_DEFAULT_SCOPE = 'CALL';
  public static readonly KEYWORDS_PRODUCT_SCOPE = 'PRODUCT';
  public static readonly KEYWORDS_PERSONA_SCOPE = 'PERSONA';
}

export enum CallTypeLabelMap {
  guided = 'Knowledge check',
  conversational = 'Role play',
}
